<template>
  <el-dialog title="添加协议价系列" :visible.sync="priceSeriesAddDialog" width="1200px">
    <div>
      <el-form :model="queryParams">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-select v-model="queryParams.symbol">
              <el-option label="品牌" value="brandName"></el-option>
              <el-option label="系列" value="seriesName"></el-option>
              <!-- <el-option label="系列组" value="bgName"></el-option> -->
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-input v-model="params.value" placeholder="请输入关键词"></el-input>
          </el-col>
          <el-col :span="10">
            <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button type @click="onSearchReset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-row style="padding:20px 0;">
        <el-col :span="12">
          <div class="table-title-left">系列查询区</div>
        </el-col>
        <el-col :span="12" style="text-align:right">
          <el-button @click="onAdd(2)" type="primary" plain>批量添加</el-button>
        </el-col>
      </el-row>
      <div class="box-table">
        <el-table
          ref="tableRefs"
          :data="priceSeriesTable"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
          @selection-change="handleSelectionChange"
          height="180"
          border
        >
          <el-table-column type="selection" :selectable="selecTable"></el-table-column>
          <el-table-column prop="brandName" label="品牌"></el-table-column>
          <!-- <el-table-column prop="bgName" label="系列组"></el-table-column> -->
          <el-table-column prop="seriesName" label="系列"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                :disabled="scope.row.isAdd === 1"
                @click="onAdd(1, scope.row)"
                type="text"
              >添加</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
      <el-row style="padding:20px 0;">
        <el-col :span="12">
          <div class="table-title-left">协议价系列区</div>
        </el-col>
        <el-col :span="12" style="text-align:right">
          <el-button @click="onDelete(2)" type="primary" plain>批量移除</el-button>
        </el-col>
      </el-row>
      <div class="box-table">
        <el-table
          ref="tableDeleteRefs"
          :data="priceSeriesListTable"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          @selection-change="handleSelectionChangeDelete"
          height="180"
          border
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column prop="brandName" label="品牌"></el-table-column>
          <!-- <el-table-column prop="bgName" label="系列组"></el-table-column> -->
          <el-table-column prop="seriesName" label="系列"></el-table-column>
          <el-table-column label="协议价设置">
            <template slot-scope="scope">
              <el-select v-model="scope.row.templateType" placeholder="请选择">
                <el-option label="折扣价" :value="1"></el-option>
                <el-option label="加价率" :value="2"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="比例">
            <template slot-scope="scope">
              <el-col :span="20">
                <el-input v-model="scope.row.templateRate"></el-input>
              </el-col>
              <el-col :span="4">
                <span>%</span>
              </el-col>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <template>
                <el-button @click="onDelete(1, scope.row)" type="text">移除</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onConfirm">确 定</el-button>
      <el-button @click="priceSeriesAddDialog = false">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import pagination from '@/components/pagination'
import { queryPageAllByPrice } from '@/api/product/productManage'
import {
  customerPriceBrSerProAdd,
  customerPriceTemplateCustomerAdd
} from '@/api/customer/customerManage'
export default {
  props: ['cptId', 'addSeriesTableId'],
  components: {
    pagination
  },
  data() {
    return {
      priceSeriesAddDialog: false,
      queryParams: {
        symbol: 'brandName'
      },
      params: {
        value: ''
      },
      priceSeriesTable: [], // 系列列表查询区
      priceSeriesListTable: [], // 协议价系列区
      currentPage: 1, // 页码
      pageSize: 30, // 当前页数
      total: 0,
      isShow: false,
      type: 1,
      loadingTable: false,
      isClick: 0, // 同步至模板状态,0默认不可同步,1数据发生改变可以同步至模板
      checkList: [], // 列表选中的数据添加
      checkListDelete: [] // 列表选中的数据移除
    }
  },
  methods: {
    // 搜索
    onSearch() {
      if (
        this.params.value === '' ||
        this.params.value === undefined ||
        this.queryParams.symbol === undefined
      ) {
        this.$message.error('搜索条件不能为空')
      } else {
        this.pageSize = 30
        this.currentPage = 1
        this.getList()
      }
    },
    onSearchReset() {
      this.queryParams = {}
      this.params = {}
      this.pageSize = 30
      this.currentPage = 1
      this.getList()
    },
    // 添加协议价系列初始方法
    priceSeriesAddInitial(type) {
      // type=1是前端做添加数据,2是调用后端接口做添加操作
      this.type = type
      this.queryParams = {
        symbol: 'brandName'
      }
      this.params = {
        value: ''
      }
      this.priceSeriesListTable = []
      this.priceSeriesAddDialog = true
      this.getList()
    },
    // 系列列表
    getList() {
      this.loadingTable = true
      const params = {
        criteriaVoList: this.$queryParams(this.queryParams, this.params),
        queryPageName: ''
      }
      // 客户详情添加协议价系列查询区列表type传0,协议价模板添加协议价查询区列表传1(这是后期调整的)
      let typeNum = 0
      if (this.type === 1) {
        typeNum = 1
      }
      queryPageAllByPrice(
        typeNum,
        this.currentPage,
        this.pageSize,
        this.$route.query.id,
        params
      )
        .then(res => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.priceSeriesTable = res.data.obj.records
            this.total = res.data.obj.total
            this.priceSeriesTable.forEach(ele => {
              const i = this.priceSeriesTable.findIndex(
                m => m.id === ele.brandId
              )
              if (i !== -1) {
                this.priceSeriesTable[i].isAdd = 1
              }
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 确定
    onConfirm() {
      if (this.type === 1) {
        // 前端做添加操作
        this.$emit('onSeriesAdd', this.priceSeriesListTable)
        this.priceSeriesAddDialog = false
      } else if (this.type === 2) {
        // 调用后端接口协议价模板系列添加
        customerPriceBrSerProAdd(this.priceSeriesListTable)
          .then(res => {
            if (res.data.code === 200) {
              this.$message.success('添加成功!')
              this.$emit('getListSeries')
              this.priceSeriesAddDialog = false
            } else {
              this.$message.success(res.data.msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      } else if (this.type === 3) {
        // 调用后端接口客户协议价系列添加
        const paramsList = this.priceSeriesListTable.map((add, index) => {
          return { ...add, cptId: this.cptId }
        })
        customerPriceTemplateCustomerAdd(this.$route.query.id, paramsList)
          .then(res => {
            if (res.data.code === 200) {
              this.$message.success('添加成功!')
              this.isClick = 1
              this.$emit('getListSeries', this.isClick, 'priceSeries')
              this.priceSeriesAddDialog = false
            } else {
              this.$message.success(res.data.msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 当前页数
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    // 系列查询区列表数据添加选中
    handleSelectionChange(row) {
      this.checkList = row
    },
    // 协议价系列列表数据移除选中
    handleSelectionChangeDelete(row) {
      this.checkListDelete = row
    },
    // 查询区列表中批量添加是2,单个添加是1
    onAdd(type, row) {
      if (type === 1) {
        this.getAddData(row)
      } else {
        // 选中后的数据
        if (this.checkList.length > 0) {
          this.checkList.forEach(item => {
            this.getAddData(item)
          })
        } else {
          this.$message.error('请选择数据!')
        }
      }
    },
    // 添加协议价系列区数据的方法
    getAddData(item) {
      const params = {
        seriesId: item.id,
        brandName: item.brandName,
        bgName: item.bgName,
        seriesName: item.seriesName,
        templateRate: 0,
        templateType: 1,
        priceType: '2'
      }
      if (this.type === 2) {
        params.cptId = this.$route.query.id
      }
      this.priceSeriesListTable.push(params)
      this.$refs.tableRefs.clearSelection()
      // 批量添加后置灰选中过的数据
      this.priceSeriesTable.forEach(res => {
        if (item.id === res.id) {
          res.isAdd = 1
        }
      })
    },
    // 移除协议价系列区数据的方法
    getDeleteData(item) {
      this.priceSeriesTable.forEach(res => {
        if (item.seriesId === res.id) {
          res.isAdd = 0
        }
      })
    },
    // 协议价系列区批量移除是2,单个移除是1
    onDelete(type, row) {
      if (type === 1) {
        this.getDeleteData(row)
        const index = this.priceSeriesListTable.indexOf(row)
        this.priceSeriesListTable.splice(index, 1)
      } else {
        // 选中后的数据
        if (this.checkListDelete.length > 0) {
          this.checkListDelete.forEach(item => {
            const index = this.priceSeriesListTable.indexOf(item)
            this.priceSeriesListTable.splice(index, 1)
            this.getDeleteData(item)
          })
        } else {
          this.$message.error('请选择数据!')
        }
      }
    },
    selecTable(row, index) {
      if (row.isAdd === 0) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
